import React from "react";
import i18n from "../../../i18n/i18n";
import Button from "../../../common/components/shared/button/button";
import {ReactComponent as GenerateReportIcon} from "../../../statics/icons/icon_generateReport.svg";
import {ReactComponent as DownloadReportIcon} from "../../../statics/icons/icon_downloadReport.svg";
import "./report.scss";
import {Api} from "../../../helpers/api";
import {HttpError} from "../../../common/components/shared/httpError/httpError";
import Loader from "../../../common/components/shared/loader/loader";
import Table from "../../../common/components/shared/table/table";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import DownloadReportPopup from "../downloadReportPopup/downloadReportPopup";
import {Utils} from "../../../helpers/utils";
import ReportSummary from "../reportSummary/reportSummary";

interface ReportProps {
    filters: JSX.Element;
    onGenerateReport: () => void;
    isReportGenerated: boolean;
    generatedReport: any[] | undefined | null;
    generatedReportResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    reportTestId: string;
    reportHeaders: string[];
    reportProperties: string[];
    reportTableRenderCell?: (row: any, property: string) => JSX.Element;
    currentPage: number;
    numberOfElements?: number;
    reportService: any | undefined;
    className?: string;
    isSummaryReportGenerated: boolean;
    generatedSummaryReport?: any | undefined | null;
    generatedSummaryReportResponse?: AxiosResponse<HttpErrorModel[] | any> | undefined;
    reportSummaryHeaders?: string[];
    reportSummaryProperties?: string[];
    isSubmitButtonBlocked?: boolean | false;
    selectedFilters: any;
    summaryCurrentPage: number;
    summaryNumberOfElements: number;
}

interface ReportState {
    downloadPopupOpen: boolean;
}

export default class Report extends React.Component <ReportProps, ReportState> {
    constructor(props: any) {
        super(props);

        this.state = {
            downloadPopupOpen: false
        };
    }

    public render(): JSX.Element {
        return (
            <div className={`report ${this.props.className}`}>
                {this.renderFiltersContent()}
                {this.renderLoaderOrReport()}
            </div>
        );
    }

    private renderLoaderOrReport() {
        if (this.props.isSubmitButtonBlocked) {
            return <Loader />;
        } else {
            return (
                <>
                    {this.props.isSummaryReportGenerated && this.renderSummaryReport()}
                    {this.props.isReportGenerated && this.renderGeneratedReportWrapper()}
                </>
            );
        }
    }

    private renderFiltersContent(): JSX.Element {
        return (
            <div className="filters-content content">
                <div className="filters">
                    {this.props.filters}
                </div>
                <Button
                    text={i18n.t("reports.filterButton")}
                    type="primary"
                    endIcon={<GenerateReportIcon/>}
                    onClick={this.props.onGenerateReport}
                    testId="generate-report-button"
                    disabled={this.props.isSubmitButtonBlocked}
                />
            </div>
        );
    }

    private renderHeader(): JSX.Element {
        return (
            <div className="header">
                {i18n.t("reports.generatedReport")}
                <Button
                    text={i18n.t("reports.downloadButton")}
                    type="primary"
                    variant="outlined"
                    endIcon={<DownloadReportIcon/>}
                    onClick={this.onClickDownload.bind(this)}
                    testId="download-report-button"
                />
            </div>
        );
    }

    private renderGeneratedReportWrapper(): JSX.Element {
        if (!Api.isSuccess(this.props.generatedReportResponse)) {
            return (
                <HttpError
                    response={this.props.generatedReportResponse}
                    cause={i18n.t("reports.errors.generateReportErrorSuffix")}
                />
            );
        } else {
            if (this.props.generatedReport === undefined) {
                return <Loader />;
            } else {
                return this.renderGeneratedReport();
            }
        }
    }

    private renderSummaryReport(): JSX.Element {
        return (
            <ReportSummary
                onGenerateReport={this.props.onGenerateReport}
                generatedReport={this.props.generatedSummaryReport}
                generatedReportResponse={this.props.generatedSummaryReportResponse}
                isReportGenerated={this.props.isSummaryReportGenerated}
                reportTestId={`${this.props.reportTestId}-summary`}
                reportProperties={this.props.reportSummaryProperties || []}
                reportHeaders={this.props.reportSummaryHeaders || []}
                reportService={this.props.reportService}
                selectedFilters={this.props.selectedFilters}
                reportTableRenderCell={this.props.reportTableRenderCell}
                currentPage={this.props.summaryCurrentPage}
                numberOfElements={this.props.summaryNumberOfElements}
            />
        );
    }

    private renderGeneratedReport(): JSX.Element {
        const testId = `${this.props.reportTestId}-table`;

        return (
            <div className="generated-report-content content">
                {this.renderHeader()}
                {this.renderDownloadPopup()}
                <div style={{width: Utils.calculateWidthOnTable()}}>
                    {this.props.generatedReport && this.props.generatedReport!.length && this.props.generatedReport!.length > 0 ? (
                        <Table
                            headers={this.props.reportHeaders}
                            rows={this.props.generatedReport!}
                            properties={this.props.reportProperties}
                            testId={testId}
                            pageable={true}
                            renderCell={this.props.reportTableRenderCell}
                            currentPage={this.props.currentPage}
                            isOldPagination={true}
                        />
                    ) : (
                        <Table
                            headers={this.props.reportHeaders}
                            rows={[]}
                            properties={this.props.reportProperties}
                            testId={testId}
                            currentPage={0}
                            numberOfElements={0}
                            pageable={false}
                        />
                    )}
                </div>
            </div>
        );
    }

    private renderDownloadPopup() {
        if (this.state.downloadPopupOpen) {
            return <DownloadReportPopup
                reportService={this.props.reportService}
                onCancel={this.onCloseDownloadPopup.bind(this)}
                isSummaryReport={false}
                selectedFilters={this.props.selectedFilters}
            />;
        }
        return <></>;
    }

    private onClickDownload() {
        this.setState({downloadPopupOpen: true});
    }

    private onCloseDownloadPopup() {
        this.setState({downloadPopupOpen: false});
    }
}